import styled from 'styled-components';
import { breakpoints } from '../../../../styles/theme';
import { VehicleSummaryStyled } from '../VehicleSummaryStyled';
import { rem } from 'polished';

export const VehicleSummaryStyledDS = styled(VehicleSummaryStyled)`
    .show-characteristics-button {
        font-size: ${({ theme }) => theme.fontSizes.h5};
    }

    .delivery-container {
        .delivery {
            background: ${({ theme }) => theme.colors.white};
            padding: 0;
        }
    }

    .benefits-wrapper {
        .benefits {
            margin-top: ${rem('15px')};
            background: ${({ theme }) => theme.colors.grey4};
            padding: ${rem('16px')};
            border-radius: ${rem('12px')};

            @media (max-width: ${breakpoints.xs}px) {
                background: ${({ theme }) => theme.colors.accordionSecondaryBg};

                .heading {
                    padding: ${rem('10px')} ${rem('10px')} 0 ${rem('10px')};
                }
            }

            .bullet-points.allow-bullet-points {
                @media (max-width: ${breakpoints.xs}px) {
                    li {
                        max-width: 98%;
                    }
                }

                .offer {
                    .info-icon-container {
                        height: 14px;
                    }
                    svg {
                        circle {
                            fill: ${({ theme }) => theme.colors.grey4};
                            stroke: ${({ theme }) => theme.colors.black1};
                        }
                    }
                }
            }

            .bullet-points.disable-bullet-points {
                padding-left: unset;
                list-style: none;
            }

            @media (max-width: ${breakpoints.xs}px) {
                .heading {
                    padding: unset;
                }
            }
        }
    }

    span.title {
        font-size: ${rem('16px')};
        padding: ${rem('31px')} 0 ${rem('31px')} 0;

        @media (max-width: ${breakpoints.sm}px) {
            display: none;
        }
    }

    .titleWithBenefits {
        .title {
            padding-bottom: ${rem('15.5px')};
        }
    }

    .summary-price-container {
        padding-top: ${rem('15.5px')};
        padding-bottom: ${rem('15.5px')};
        border-top: 1px solid ${({ theme }) => theme.colors.grey16};
        border-bottom: 1px solid ${({ theme }) => theme.colors.grey16};
        width: 100%;

        .content {
            .header {
                .catalog-price-title {
                    font-size: ${({ theme }) => theme.fontSizes.h6};
                    border-top: unset;
                    border-bottom: 1px solid ${({ theme }) => theme.colors.grey16};
                }
            }
            .body {
                .body-wrapper {
                    .heading-wrapper {
                        @media (max-width: ${breakpoints.xs}px) {
                            flex-direction: column;

                            .price {
                                margin-top: ${rem('15px')};
                            }
                        }
                        .heading {
                            .heading-content {
                                display: flex;
                                flex-direction: column;
                            }
                        }
                        .price {
                            font-size: ${({ theme }) => theme.fontSizes.h4};
                        }
                    }
                    .totalMonthlyPriceContainer {
                        .footer {
                            font-size: ${({ theme }) => theme.fontSizes.h6};
                        }
                        .totalMonthlyPriceWrapper {
                            .price {
                                font-size: ${({ theme }) => theme.fontSizes.h4};
                            }
                            .prefix {
                                line-height: ${rem('25px')};
                            }
                        }
                    }
                }
            }
        }

        .totalMonthlyPriceContainer {
            @media (max-width: ${breakpoints.xs}px) {
                display: flex;
                width: 100%;
                flex-direction: column;
                align-items: flex-start;

                .footer {
                    text-align: left !important;
                }

                .totalMonthlyPriceWrapper .price .or {
                    margin-left: unset;
                }
            }
        }
    }
`;
